module.exports = __webpack_public_path__ + "assets/311d0685e1775390693da5b21a8d6849.mp4";